<template>
  <v-app>
    <component :is="layout">
      <router-view />
    </component>
  </v-app>
</template>

<script>
import DefaultLayout from "./layouts/DefaultLayout";
import FullPageLayout from "./layouts/FullPageLayout";
export default {
  name: "App",
  components: {
    DefaultLayout,
    FullPageLayout,
  },
  async mounted() {
    await this.$store.dispatch("authAction");
  },
  data() {
    return {
      drawer: null,
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
  },
};
</script>
